module.exports = __webpack_public_path__ + "img/thumb_image1.198cbd22.jpg";